import { Component, OnInit, Output, EventEmitter, AfterViewInit, Input, OnChanges } from '@angular/core';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { FlagService, ToastService, DataService } from '@core/services';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { faPeopleArrows, faInfoCircle, faStar, faHourglass, faRedo } from '@fortawesome/free-solid-svg-icons';
import * as faReg from '@fortawesome/free-regular-svg-icons';
import {
  FilteredSortedPagedDto,
  CodeModelDto,
  HIPInsuredPersonFromHIPDto, HIPContractDto
} from 'src/app/modules/_services/api/@generated/models';
import { DomSanitizer } from '@angular/platform-browser';
import { GeneralUtils } from '@shared/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-family-juncture',
  templateUrl: './family-juncture.component.html',
  styleUrls: ['./family-juncture.component.scss'],
  standalone: false
})

export class FamilyJunctureComponent implements OnInit, AfterViewInit, OnChanges {
  faPropleArrows = faPeopleArrows;
  faInfoCircle = faInfoCircle;
  faStar = faStar;
  faRegStar = faReg.faStar;
  faHourglass = faHourglass;
  faRedo = faRedo;
  summaryFlag = false;
  linkTypeFlag = false;
  familyCaptchaCountdown = 0;
  couponCaptchaCountdown = 0;
  captchaPath: any;

  public errorMessage = '';
  public captchaMessage = '';

  _currentYear = new Date().getFullYear();
  _birthYear = '';
  _birthMonth: string;
  _birthDay = '';

  contractorName = JSON.parse(sessionStorage.getItem('HIPContract')).contractorName;

  FilteredSortedPagedDto: FilteredSortedPagedDto = {
    filtering: [],
    paging: null,
    sorting: null
  };

  codeModelDto: CodeModelDto = {
    codeText: '',
    generatedAccessToken: ''
  }

  insurantData = this.DropdownFrame.returnInsurantData();

  @Input() lang: string; // to trigger onChanges..
  @Input() HIPContractDto: HIPContractDto;

  public customerType = '';

  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  _familyMemberNameInput = '';
  _familyMemberBirthDate = '';
  _couponCodeInput = '';
  _captchaInputValid = false;
  _captchaInput: string;

  constructor(private DropdownFrame: DropdownFrameComponent, private DomSanitizer: DomSanitizer, public DataService: DataService, public FlagService: FlagService, public ToastService: ToastService, private api: APIClient,
              private translate: TranslateService,
              public generalUtils: GeneralUtils) { }

  ngOnInit(): void {
//    for(let i = 0; i < 150; i++) {
//      this._availableYears[i] = this._currentYear - i;
//    }

    if (this.DataService.isPartneri() && sessionStorage.getItem('couponCode')) {
      const code = sessionStorage.getItem('couponCode');
      if (this.checkCouponCode(code)) {
        this._couponCodeInput = code;
      }
    }

    if(this.DataService.connectionLinkType === "PARTNERI") {
      // this.linkTypeFlag = false;
      // window.location.href.includes('&InterruptionId=')? this.linkTypeFlag = true : this.linkTypeFlag = false;
      sessionStorage.choosenOffer || sessionStorage.preChoosenOffer ? this.linkTypeFlag = false : this.linkTypeFlag = true;
      //SET local for testing purposes
      //this.linkTypeFlag = false;
    } else {
      this.linkTypeFlag = true;
    }

    //modify captchaCountdowns if its present in sessionStorage
    let familyCaptchaCountdown = JSON.parse(sessionStorage.getItem('familyCaptchaCountdown'));
    let couponCaptchaCountdown = JSON.parse(sessionStorage.getItem('couponCaptchaCountdown'));

    if(familyCaptchaCountdown) {
      this.familyCaptchaCountdown = familyCaptchaCountdown;
      this.checkCaptchaCountdown();
    }
    if(couponCaptchaCountdown) {
      this.couponCaptchaCountdown = couponCaptchaCountdown;
      this.checkCaptchaCountdown();
    }

    const person = sessionStorage.getItem('HIPInsuredPersonFromHIPDto');
    if (person) {
      const personObj = JSON.parse(person);
      this.loadDataFromSessionStorage(personObj);
    }
  }

  ngOnChanges(): void {
    if (this.HIPContractDto) {
      this.customerType = this.translate.store.currentLang === 'en' ?
        this.HIPContractDto.hipCustomerType.customerTypeGenitiveEnglish :
        this.HIPContractDto.hipCustomerType.customerTypeGenitive;
    }
  }

  private checkCouponCode(code): boolean {
    const codeFormat = this.DataService.isPartneri() ? /^[a-zA-Z0-9.\-_@]{0,15}$/ : /^[a-zA-Z0-9]{0,15}$/;
    return codeFormat.test(code);
  }

  private loadDataFromSessionStorage(data: HIPInsuredPersonFromHIPDto): void {
    if (data.couponCode) {
      this._couponCodeInput = data.couponCode;
    }
  }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.DataService.fixInfoContainerHeight + 215);

    this._birthYear = this._currentYear.toString();
    this._birthMonth = '01';
    this._birthDay = '01';

    this._familyMemberBirthDate = this._birthYear + '-' + this._birthMonth + '-' + this._birthDay;
  }

  inputChange() {
    this._familyMemberBirthDate = this._birthYear + '-' + this._birthMonth + '-' + this._birthDay;

    if(this._familyMemberNameInput === '' || this._familyMemberBirthDate === '') {
      this.summaryFlag = false;
    } else this.summaryFlag = true;
  }

  sendFamilyMember() {
    let employee = {
      id: null,
      koopFrameContractId: null,
      name: this._familyMemberNameInput,
      birthDate: this._familyMemberBirthDate
    };

    //mocked
    //'46413265', 'teszt teszt', '1951-07-18'
    if (this.DataService.connectionLinkType !== 'KOMPAKT_HOZZATARTOZOI') {
      this.api.checkEmployee({
        passiveKoopFrameContractId: this.insurantData.koopFrameContractId,
        name: this._familyMemberNameInput,
        birthDate: this._familyMemberBirthDate
      }).subscribe(response => {
        employee.koopFrameContractId = response.koopFrameContractId;
        employee.id = response.id;
        this.familyJunctureClick();
        this.newInsurantDataLocation.emit('employee');
        this.newInsurantDataEvent.emit(employee);
      }, error => {
        this.familyCaptchaCountdown++;
        sessionStorage.setItem('familyCaptchaCountdown', JSON.stringify(this.familyCaptchaCountdown));
        this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
        this.checkCaptchaCountdown();
      });
    } else {
      this.familyJunctureClick();
      this.newInsurantDataLocation.emit('employee');
      this.newInsurantDataEvent.emit(employee);
    }
  }

  checkCaptchaCountdown() {
    if(this.familyCaptchaCountdown >= 3) {
      this.getCaptchaPicture();
    }
    if(this.couponCaptchaCountdown >= 3) {
      this.getCaptchaPicture();
    }
  }

  getCaptchaPicture() {
    this.api.getCaptcha().subscribe(response => {
      this.codeModelDto.generatedAccessToken = response.accessToken;
      let imgURL = 'data:image/png;base64,' + response.picture;
      this.captchaPath = this.DomSanitizer.bypassSecurityTrustUrl(imgURL);
    }, error => {
      this.ToastService.initializeMessage(error.message, 'error');
    });
  }

  validateCaptcha() {
    this.codeModelDto.codeText = this._captchaInput;
    this.captchaMessage = '';
    this.api.checkCaptcha({codeModel: this.codeModelDto}).subscribe(response => {
      if(response.success === 1) {
        this.familyCaptchaCountdown = 0;
        this.couponCaptchaCountdown = 0;
        sessionStorage.setItem('familyCaptchaCountdown', JSON.stringify(this.familyCaptchaCountdown));
        sessionStorage.setItem('couponCaptchaCountdown', JSON.stringify(this.couponCaptchaCountdown));
      } else {
        this.captchaMessage = response.errorMessage;
        // this.ToastService.initializeMessage(response.errorMessage, 'warning');
        this.reloadCaptcha();
      }
    }, error => {
      this.captchaMessage = error.error?.validationErrors[0]?.errorMessage;
      // this.ToastService.initializeMessage(error.message, 'error');
    });
  }

  reloadCaptcha() {
    this.getCaptchaPicture();
    this._captchaInputValid = false;
    this._captchaInput = '';
    this.captchaMessage = '';
  }

  captchaInputChange(event: any) {
    event.length > 0? this._captchaInputValid = true : this._captchaInputValid = false;
  }

  public checkCode(): void {
    if (this.checkCouponCode(this._couponCodeInput)) {
      this.errorMessage = '';
    } else {
      this.errorMessage =
        this.DataService.isPartneri() ?
//        'Az azonosító kód csak számokat, kis/nagy betűket valamit „.”, „-”, „_” és „@” karaketereket tartalmazhat legfeljebb 15 karakter hosszan.' :
//        'Az azonosító kód csak számokat és kis/nagy betűket tartalmazhat legfeljebb 15 karakter hosszan.';
      this.translate.instant('missing.code.error1') :
      this.translate.instant('missing.code.error2');
    }
  }

  sendCouponCode(mode: string) {
    if (mode === 'none') {
      this._couponCodeInput = '';
      this.errorMessage = '';
    }

    if (!this.checkCouponCode(this._couponCodeInput)) {
      return;
    }

    //00012 - coupon code
    if(this._couponCodeInput.length == 0) {
      this.DataService.HIPInsuredPersonFromHIPDto.couponCode = this._couponCodeInput;
      sessionStorage.setItem('HIPInsuredPersonFromHIPDto', JSON.stringify(this.DataService.HIPInsuredPersonFromHIPDto));
      this.familyJunctureClick();
      return
    }

    this.errorMessage = '';
//    this.api.checkCouponCode({passiveKoopFrameContractId: this.insurantData.koopFrameContractId, couponCode: this._couponCodeInput}).subscribe(response => {
    this.DataService.HIPInsuredPersonFromHIPDto.couponCode = this._couponCodeInput;
    sessionStorage.setItem('HIPInsuredPersonFromHIPDto', JSON.stringify(this.DataService.HIPInsuredPersonFromHIPDto));
    this.familyJunctureClick();
//    }, error => {
//      this.couponCaptchaCountdown++;
//      sessionStorage.setItem('couponCaptchaCountdown', JSON.stringify(this.couponCaptchaCountdown));
//      // this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
//      this.errorMessage = error.error.validationErrors[0].errorMessage;
//      this.checkCaptchaCountdown();
//    });
  }

  familyJunctureClick() {
    this.DropdownFrame.junctureClick('userdataJunctureFlag', 3);
  }
}
